import React from "react";
import { Box, Button, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { DevEmailSendWarning } from "./DevEmailSendWarning";
import "./SendInviteConfirmModal.css";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 480,
  maxWidth: "calc(100vw - 32px)",
  bgcolor: "background.paper",
  borderRadius: "12px",
  boxShadow: 24,
  p: "28px 34px 34px",
  outline: "none",
  textAlign: "center",
};

export const SendInviteConfirmModal = ({
  open,
  onClose,
  onConfirm,
  confirming = false,
  recipients = [],
}) => {
  return (
    <Modal
      open={open}
      onClose={confirming ? undefined : onClose}
      aria-labelledby="send-invite-confirm-title"
    >
      <Box sx={modalStyle} className="send-invite-confirm-modal">
        <button
          type="button"
          className="send-invite-confirm-modal__close"
          onClick={onClose}
          disabled={confirming}
          aria-label="Close"
        >
          <CloseIcon sx={{ fontSize: 18 }} />
        </button>

        <h2 id="send-invite-confirm-title">Send Promotion Event Invite?</h2>
        <p className="send-invite-confirm-modal__body">
          An invite will be sent to the selected employees for the promotion
          event. Once the invite is sent,{" "}
          <span className="send-invite-confirm-modal__highlight">
            the event cannot be edited.
          </span>
        </p>
        <DevEmailSendWarning recipients={recipients} />

        <div className="send-invite-confirm-modal__actions">
          <Button
            type="button"
            variant="contained"
            className="send-invite-confirm-modal__btn-cancel"
            disableElevation
            onClick={onClose}
            disabled={confirming}
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="contained"
            className="send-invite-confirm-modal__btn-confirm"
            disableElevation
            onClick={onConfirm}
            disabled={confirming}
          >
            {confirming ? "Sending…" : "Send Invite"}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};
